// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   ORIGINAL CSS — untouched
───────────────────────────────────────────── */

.denomination-input {
  width: 100%;
  height: 50px !important;
}

.dark .denomination-input {
  background-color: #2b2f42;
  color: white;
}

.note-wrapper-text {
  /* width: 60%; */
  text-align: center !important;
}

.session-closure-data {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.deno-container {
  margin: 3.2rem auto 1rem auto;
  display: flex;
  flex-direction: column;
  width: 80%;
  justify-content: center;
  /* border: 1px solid red; */
  padding: 5px;
  margin-top: 4.3rem;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 10px;
}

.denominations {
  width: 100%;
  flex: 1;
}

.eventMetrics {
  width: 50%;
  height: 100%;
  /* border: 1px solid black; */
  display: flex;
  flex-direction: column;
}

.data-heading {
  width: 100%;
  text-align: center;
  padding: 5px;
}

.metric-data-div {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0px 10px 10px 10px;
  border: 0.1px solid rgba(128, 128, 128, 0.312);
}

.metric-loader {
  width: 100%;
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.event-box {
  border: 0.1px solid rgba(128, 128, 128, 0.312);
  border-radius: 10px;
  height: 80px;
}

.note-currency-text {
  text-align: center !important;
}

.dark .deno-container {
  color: #fff;
}

@media (max-width: 576px) {
  .deno-container {
    width: 80%;
  }
}

.dark .metric-data-div {
  color: white !important;
  background-color: var(--dark-background);
  border: 0.5px solid rgb(255 255 255 / 69%);
}

.tryCss {
  background-color: red;
}

.new-deno-container {
  width: 100%;
  margin: 80px 17px 0px 17px;
}

.new-deno-inner-container {
  background-color: var(--surface-white);
  padding: 10px;
  border-radius: 8px;
}

.new-deno-heading-text {
  font-weight: 700;
  margin-bottom: 4px;
}

.new-deno-table {
  text-align: left;
}

.new-deno-table th {
  background-color: #fafafa;
  padding: 6px 8px 6px 10px;
}

.new-deno-table td {
  padding: 6px 8px 6px 10px;
  font-weight: 600;
}

.denomination-input-new {
  width: 100%;
  text-align: left;
  border: 0;

  display: flex;
  height: 40px;
  padding: 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid var(--Gray-200, #e9eaec);
  background: var(--White, #fff);
}

.new-deno-action-buttons {
  display: flex;
  gap: 8px;
}

.new-deno-metrics-txt {
  font-weight: 400;
  font-size: 0.813rem;
}

.deno-parent-container {
  display: flex;
  padding: 12px 16px 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  /* margin-top: 70px; */
  width: 100%;
  margin-bottom: 70px;
  /* background-color: #fff; */
}

.deno-top-container-section {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}

.progressbar-container-div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
}

.progressbar-container-label-div {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}

.progressbar-label-p {
  color: var(--Gray-800, #252b36);

  /* Text md/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.progress-bar-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  width: 100%;
}

.cancel-save-btn-div {
  display: flex;
  align-items: center;
  gap: 12px;
}

.deno-cart-metrics-section {
  color: var(--Surface-G5, #333);
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
  text-transform: capitalize;
  align-self: stretch;
}

.deno-cart-metrics-card-container {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Gray-200, #e9eaec);
}

.deno-cart-metrics-card {
  display: flex;
  padding: 16px 12px;
  align-items: flex-start;
  gap: 17px;
  flex: 1 0 0;
  align-self: stretch;

  border-right: 1px solid var(--Surface-G1, #e6e6e6);
  background: #fff;
}

.cart-metrics-card-inner-container-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  height: 100%;
  justify-content: space-between;
}

.inner-container-wrapper-label {
  color: var(--Gray-400, #a4a7af);

  /* Text xs/Medium */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.inner-container-wrapper-value {
  color: var(--Surface-G5, #333);

  /* Text xl/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.deno-event-metrics-section {
  color: var(--Surface-G5, #333);
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
  text-transform: capitalize;
  align-self: stretch;
}

.event-metrics-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.event-metrics-card-row-1-container {
  display: flex;
  width: 100%;
  height: 90px;
  align-items: flex-start;
  gap: 12px;
}

.event-metrics-row-1-cards {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid var(--Gray-200, #e9eaec);
  background: #fff;
  box-shadow:
    0 15px 4px 0 rgba(185, 201, 223, 0),
    0 10px 4px 0 rgba(185, 201, 223, 0.01),
    0 6px 3px 0 rgba(185, 201, 223, 0.05),
    0 2px 2px 0 rgba(185, 201, 223, 0.09),
    0 1px 1px 0 rgba(185, 201, 223, 0.1);
}

.row-1-card-sub-container {
  display: flex;
  padding-left: 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-left: 4px solid var(--Blue-B0, #0860e6);
}

.row-1-card-sub-container-p {
  color: var(--Surface-G4, #6b6b6b);

  /* Text sm/Semibold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  flex: 1 0 0;
}

.row-2-card-sub-container {
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}

.row-2-card-sub-container-p {
  color: var(--Surface-G5, #333);

  /* Text xl/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.deno-denomination-section {
  color: var(--Surface-G5, #333);
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
  text-transform: capitalize;
  align-self: stretch;
}

.denomination-payment-section-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}

.denominations-currency-select-container {
  border-radius: 8px;
  border: 1px solid var(--Gray-300, #d5d7db);
  display: flex;
  /* height: 576px; */
  align-items: flex-start;
  align-self: stretch;
}

.currency-select-container-left-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
}

.currency-select-container-right-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
}

.denominations-payment-total-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.denominations-payment-total-div-p {
  color: var(--Black, #000);

  /* Text lg/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.denominations-payment-total-div-amount-p {
  color: var(--Blue-ORG, #007aff);

  /* Text lg/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

/* ─────────────────────────────────────────────
   NEW CSS — Closing Cash Check UI
   Matches the reference screenshot design.
   All new classes prefixed with closing-cash-
   or deno-card- / deno-grid- to avoid conflicts.
───────────────────────────────────────────── */

/* ── Header row: title + total badge ── */
.closing-cash-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  /* margin-bottom: 4px; */
}

.closing-cash-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.closing-cash-title {
  color: #0f1f3d;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.closing-cash-subtitle {
  color: #6b7280;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin: 0;
}

/* Total Cash badge — green pill matching reference */
.closing-cash-total-badge {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 16px;
  padding: 12px 24px;
  min-width: 140px;
  text-align: right;
}

.closing-cash-total-label {
  color: #16a34a;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 2px 0;
}

.closing-cash-total-amount {
  color: #052e16;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  margin: 0;
}

/* ── Card section: white card wrapping grid + button ── */
.deno-card-section {
  width: 100%;
  background-color: #ffffff;
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* ── Denomination grid: 3 columns ── */
.deno-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  gap: 1px;
  /* background-color: #f1f5f9; */
}

/* Individual cell */
.deno-grid-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 5px 24px;
  background-color: #ffffff;
  transition: background-color 0.15s ease;
}

.deno-grid-item:hover {
  background-color: #f8fafc;
}

/* Note denomination badge — rounded pill */
.deno-note-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  /* height: 40px; */
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #334155;
  flex-shrink: 0;
}

/* Quantity input area */
.deno-qty-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.deno-qty-label {
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  display: block;
}

.deno-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.deno-input-prefix {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 14px;
  pointer-events: none;
  z-index: 1;
}

/* Override denomination-input-new for grid usage */
.deno-grid-input {
  padding-left: 28px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  width: 100%;
  box-sizing: border-box;
}

.deno-grid-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

/* Per-row total */
.deno-row-total {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 72px;
  flex-shrink: 0;
}

.deno-row-total-label {
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  margin: 0 0 2px 0;
}

.deno-row-total-amount {
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

/* ── Proceed button row ── */
.deno-proceed-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #f8fafc;
}

/* Responsive: 2 columns on tablet, 1 on mobile */
@media (max-width: 900px) {
  .deno-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .deno-grid {
    grid-template-columns: 1fr;
  }

  .closing-cash-header {
    flex-direction: column;
    gap: 12px;
  }

  .closing-cash-total-badge {
    align-items: flex-start;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/denomination/denomination.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;;EAET,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;;EAEnB,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;;EAE/B,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;;EAEnB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;;EAE/B,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;;EAE9B,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB;;;;;wCAKsC;AACxC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;;EAEjC,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;;EAE9B,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;;EAEzB,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;;EAE/B,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;+CAK+C;;AAE/C,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qCAAqC;;EAErC,QAAQ;EACR,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB;;yBAEuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":["/* ─────────────────────────────────────────────\n   ORIGINAL CSS — untouched\n───────────────────────────────────────────── */\n\n.denomination-input {\n  width: 100%;\n  height: 50px !important;\n}\n\n.dark .denomination-input {\n  background-color: #2b2f42;\n  color: white;\n}\n\n.note-wrapper-text {\n  /* width: 60%; */\n  text-align: center !important;\n}\n\n.session-closure-data {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.deno-container {\n  margin: 3.2rem auto 1rem auto;\n  display: flex;\n  flex-direction: column;\n  width: 80%;\n  justify-content: center;\n  /* border: 1px solid red; */\n  padding: 5px;\n  margin-top: 4.3rem;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border-radius: 10px;\n}\n\n.denominations {\n  width: 100%;\n  flex: 1;\n}\n\n.eventMetrics {\n  width: 50%;\n  height: 100%;\n  /* border: 1px solid black; */\n  display: flex;\n  flex-direction: column;\n}\n\n.data-heading {\n  width: 100%;\n  text-align: center;\n  padding: 5px;\n}\n\n.metric-data-div {\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  padding: 0px 10px 10px 10px;\n  border: 0.1px solid rgba(128, 128, 128, 0.312);\n}\n\n.metric-loader {\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.event-box {\n  border: 0.1px solid rgba(128, 128, 128, 0.312);\n  border-radius: 10px;\n  height: 80px;\n}\n\n.note-currency-text {\n  text-align: center !important;\n}\n\n.dark .deno-container {\n  color: #fff;\n}\n\n@media (max-width: 576px) {\n  .deno-container {\n    width: 80%;\n  }\n}\n\n.dark .metric-data-div {\n  color: white !important;\n  background-color: var(--dark-background);\n  border: 0.5px solid rgb(255 255 255 / 69%);\n}\n\n.tryCss {\n  background-color: red;\n}\n\n.new-deno-container {\n  width: 100%;\n  margin: 80px 17px 0px 17px;\n}\n\n.new-deno-inner-container {\n  background-color: var(--surface-white);\n  padding: 10px;\n  border-radius: 8px;\n}\n\n.new-deno-heading-text {\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.new-deno-table {\n  text-align: left;\n}\n\n.new-deno-table th {\n  background-color: #fafafa;\n  padding: 6px 8px 6px 10px;\n}\n\n.new-deno-table td {\n  padding: 6px 8px 6px 10px;\n  font-weight: 600;\n}\n\n.denomination-input-new {\n  width: 100%;\n  text-align: left;\n  border: 0;\n\n  display: flex;\n  height: 40px;\n  padding: 10px;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n\n  border-radius: 6px;\n  border: 1px solid var(--Gray-200, #e9eaec);\n  background: var(--White, #fff);\n}\n\n.new-deno-action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.new-deno-metrics-txt {\n  font-weight: 400;\n  font-size: 0.813rem;\n}\n\n.deno-parent-container {\n  display: flex;\n  padding: 12px 16px 8px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n  /* margin-top: 70px; */\n  width: 100%;\n  margin-bottom: 70px;\n  /* background-color: #fff; */\n}\n\n.deno-top-container-section {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n  align-self: stretch;\n}\n\n.progressbar-container-div {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n}\n\n.progressbar-container-label-div {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n}\n\n.progressbar-label-p {\n  color: var(--Gray-800, #252b36);\n\n  /* Text md/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.progress-bar-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n  width: 100%;\n}\n\n.cancel-save-btn-div {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.deno-cart-metrics-section {\n  color: var(--Surface-G5, #333);\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 130%; /* 20.8px */\n  text-transform: capitalize;\n  align-self: stretch;\n}\n\n.deno-cart-metrics-card-container {\n  display: flex;\n  align-items: flex-start;\n  align-self: stretch;\n  border-radius: 8px;\n  border: 1px solid var(--Gray-200, #e9eaec);\n}\n\n.deno-cart-metrics-card {\n  display: flex;\n  padding: 16px 12px;\n  align-items: flex-start;\n  gap: 17px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  border-right: 1px solid var(--Surface-G1, #e6e6e6);\n  background: #fff;\n}\n\n.cart-metrics-card-inner-container-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  height: 100%;\n  justify-content: space-between;\n}\n\n.inner-container-wrapper-label {\n  color: var(--Gray-400, #a4a7af);\n\n  /* Text xs/Medium */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.inner-container-wrapper-value {\n  color: var(--Surface-G5, #333);\n\n  /* Text xl/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.deno-event-metrics-section {\n  color: var(--Surface-G5, #333);\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 130%; /* 20.8px */\n  text-transform: capitalize;\n  align-self: stretch;\n}\n\n.event-metrics-card-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n}\n\n.event-metrics-card-row-1-container {\n  display: flex;\n  width: 100%;\n  height: 90px;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.event-metrics-row-1-cards {\n  display: flex;\n  padding: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n  border-radius: 8px;\n  border: 1px solid var(--Gray-200, #e9eaec);\n  background: #fff;\n  box-shadow:\n    0 15px 4px 0 rgba(185, 201, 223, 0),\n    0 10px 4px 0 rgba(185, 201, 223, 0.01),\n    0 6px 3px 0 rgba(185, 201, 223, 0.05),\n    0 2px 2px 0 rgba(185, 201, 223, 0.09),\n    0 1px 1px 0 rgba(185, 201, 223, 0.1);\n}\n\n.row-1-card-sub-container {\n  display: flex;\n  padding-left: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  border-left: 4px solid var(--Blue-B0, #0860e6);\n}\n\n.row-1-card-sub-container-p {\n  color: var(--Surface-G4, #6b6b6b);\n\n  /* Text sm/Semibold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n\n  flex: 1 0 0;\n}\n\n.row-2-card-sub-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n}\n\n.row-2-card-sub-container-p {\n  color: var(--Surface-G5, #333);\n\n  /* Text xl/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.deno-denomination-section {\n  color: var(--Surface-G5, #333);\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 130%; /* 20.8px */\n  text-transform: capitalize;\n  align-self: stretch;\n}\n\n.denomination-payment-section-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n}\n\n.denominations-currency-select-container {\n  border-radius: 8px;\n  border: 1px solid var(--Gray-300, #d5d7db);\n  display: flex;\n  /* height: 576px; */\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.currency-select-container-left-box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n}\n\n.currency-select-container-right-box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n}\n\n.denominations-payment-total-div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n}\n\n.denominations-payment-total-div-p {\n  color: var(--Black, #000);\n\n  /* Text lg/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.denominations-payment-total-div-amount-p {\n  color: var(--Blue-ORG, #007aff);\n\n  /* Text lg/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n/* ─────────────────────────────────────────────\n   NEW CSS — Closing Cash Check UI\n   Matches the reference screenshot design.\n   All new classes prefixed with closing-cash-\n   or deno-card- / deno-grid- to avoid conflicts.\n───────────────────────────────────────────── */\n\n/* ── Header row: title + total badge ── */\n.closing-cash-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  /* margin-bottom: 4px; */\n}\n\n.closing-cash-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.closing-cash-title {\n  color: #0f1f3d;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.closing-cash-subtitle {\n  color: #6b7280;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  margin: 0;\n}\n\n/* Total Cash badge — green pill matching reference */\n.closing-cash-total-badge {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  background-color: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 16px;\n  padding: 12px 24px;\n  min-width: 140px;\n  text-align: right;\n}\n\n.closing-cash-total-label {\n  color: #16a34a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin: 0 0 2px 0;\n}\n\n.closing-cash-total-amount {\n  color: #052e16;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0;\n}\n\n/* ── Card section: white card wrapping grid + button ── */\n.deno-card-section {\n  width: 100%;\n  background-color: #ffffff;\n  border-radius: 24px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n/* ── Denomination grid: 3 columns ── */\n.deno-grid {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n\n  gap: 1px;\n  /* background-color: #f1f5f9; */\n}\n\n/* Individual cell */\n.deno-grid-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 5px 24px;\n  background-color: #ffffff;\n  transition: background-color 0.15s ease;\n}\n\n.deno-grid-item:hover {\n  background-color: #f8fafc;\n}\n\n/* Note denomination badge — rounded pill */\n.deno-note-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  /* height: 40px; */\n  background-color: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #334155;\n  flex-shrink: 0;\n}\n\n/* Quantity input area */\n.deno-qty-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.deno-qty-label {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  color: #94a3b8;\n  display: block;\n}\n\n.deno-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.deno-input-prefix {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94a3b8;\n  font-size: 14px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* Override denomination-input-new for grid usage */\n.deno-grid-input {\n  padding-left: 28px !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n  height: 40px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.deno-grid-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n/* Per-row total */\n.deno-row-total {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  min-width: 72px;\n  flex-shrink: 0;\n}\n\n.deno-row-total-label {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  color: #94a3b8;\n  margin: 0 0 2px 0;\n}\n\n.deno-row-total-amount {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n/* ── Proceed button row ── */\n.deno-proceed-row {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 20px 24px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f8fafc;\n}\n\n/* Responsive: 2 columns on tablet, 1 on mobile */\n@media (max-width: 900px) {\n  .deno-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .deno-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .closing-cash-header {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .closing-cash-total-badge {\n    align-items: flex-start;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
